
import Hero from '@/components/one-on-one-coaching/Hero'
import ThereForYou from '@/components/one-on-one-coaching/ThereForYou'
import FAQs from '@/components/one-on-one-coaching/FAQs'
import WhatsIncluded from '@/components/one-on-one-coaching/WhatsIncluded'
import ByCompletingThisProgram from '@/components/one-on-one-coaching/ByCompletingThisProgram'
import UnsureIfItsRightForYou from '@/components/one-on-one-coaching/UnsureIfItsRightForYou'
import ThisProgramIsForYou from '@/components/one-on-one-coaching/ThisProgramIsForYou'
import WhatMyClientsAreSaying from '@/components/one-on-one-coaching/WhatMyClientsAreSaying'
import HaveQuestionsContainer from '@/components/one-on-one-coaching/HaveQuestionsContainer'
import AboutFionaWithOneOnOneTestimonials from '@/components/one-on-one-coaching/AboutFionaWithOneOnOneTestimonials'
export default {
  name: 'OneOnOneCoachingPage',
  components: {
    AboutFionaWithOneOnOneTestimonials,
    HaveQuestionsContainer,
    WhatMyClientsAreSaying,
    ThisProgramIsForYou,
    UnsureIfItsRightForYou,
    ByCompletingThisProgram,
    WhatsIncluded,
    ThereForYou,
    FAQs,
    Hero,
  },
  layout: 'noheader',
  data() {
    return {
      title: `Personalized Nutrition Coaching | ${this.$config.siteTitle}`,
      description:
        'Dive deep into your goals in this 8-week program & master the process of changing your diet so you can fall in love with food that loves you back.',
    }
  },
  head() {
    return {
      title: this.title,
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: this.description,
        },
        { hid: 'og:title', property: 'og:title', content: this.title },
        { hid: 'og:url', property: 'og:url', content: this.pageUrl },
        {
          hid: 'og:description',
          property: 'og:description',
          content: this.description,
        },

        // twitter card
        { hid: 'twitter:title', name: 'twitter:title', content: this.title },
        { hid: 'twitter:url', name: 'twitter:url', content: this.pageUrl },
        {
          hid: 'twitter:description',
          name: 'twitter:description',
          content: this.description,
        },
        {
          hid: 'og:image',
          name: 'og:image',
          content: '/images/one-health/og.png',
        },
        {
          hid: 'twitter:image',
          name: 'twitter:image',
          content: '/images/one-health/og.png',
        },
        {
          hid: 'og:image:width',
          name: 'og:image:width',
          content: '1200',
        },
        {
          hid: 'og:image:height',
          name: 'og:image:height',
          content: '630',
        },
      ],
    }
  },
  computed: {
    pageUrl() {
      return `${this.$config.baseURL}${this.$route.fullPath}`
    },
  },
}
